import { Text } from '@gympass/yoga';

import { ItemListProps } from './types';

import * as S from './styles';

const ItemList: React.FC<ItemListProps> = (
  { title, dateInfo, description, author, buttonTitle, onClick },
  props,
) => {
  return (
    <S.ItemList data-testid="itemList" {...props}>
      <S.ItemListContainer>
        <div>
          <S.ItemListTitle>{title}</S.ItemListTitle>
          <Text.Tiny color="deep">{`${dateInfo}  |  ${author}`}</Text.Tiny>
          <S.ItemListText>{description}</S.ItemListText>
        </div>
        <S.ItemListLinkButton onClick={() => onClick()}>
          {buttonTitle}
        </S.ItemListLinkButton>
      </S.ItemListContainer>
    </S.ItemList>
  );
};

export default ItemList;
